// import CleverTap from 'clevertap-web-sdk';
function trackEvent(eventName, eventData) {
  trackWithCleverTap(eventName, eventData);
}

let isMoEListenerAttached = false;

function trackMoengageEvents(eventName, eventData) {
  if (typeof eventName !== 'string') return;
  if (!window?.Moengage) return;

  try {
    const { Moengage } = window;
    Moengage.getUserId();
    window.Moengage.track_event(eventName, eventData);
  } catch (error) {
    isMoEListenerAttached = true;
    window.addEventListener('MOE_LIFECYCLE', function handler(e) {
      if (e.detail.name === 'SDK_INITIALIZATION_COMPLETED') {
        window.Moengage.track_event(eventName, eventData);
      }

      window.removeEventListener('MOE_LIFECYCLE', handler);
      isMoEListenerAttached = false;
    });
  }
}

function trackWithCleverTap(eventName, eventData) {
  // CleverTap.event.push(eventName, eventData);
}

export { trackEvent, trackMoengageEvents };
